module.exports = __webpack_public_path__ + "img/icon-29.2284ca54.png";